import { useState } from 'react';
import { Tag, tagIsUnique, updateTag } from '../../../../store/Tags';
import { CircularProgress, TextField } from '@mui/material';
import { useSnackbar } from '../../../../Context/SnackbarContext';
import { TextBlock } from '../../../Atoms/Text';

export type TagNameRendererProps = {
  tag: Tag;
};

export function TagNameRenderer({ tag }: TagNameRendererProps) {
  const [updating, setUpdating] = useState(false);
  const [tagName, setTagName] = useState(tag.name);
  const [isEditing, setIsEditing] = useState(false);
  const { setSnack } = useSnackbar();

  const handleNameChange = async (name: string) => {
    setTagName(name);
  };

  const handleSubmitName = async () => {
    if (!tagIsUnique({ ...tag, name: tagName })) {
      setSnack({ message: 'Tag with same name already exists', type: 'error', open: true });
      return;
    }
    setIsEditing(false);
    setUpdating(true);
    const update = { ...tag, name: tagName };
    await updateTag(update, true);
    setUpdating(false);
  };

  return (
    <div className="w-full h-full">
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
      <div
        data-testid="tag-name"
        className="w-full h-full"
        onBlur={() => setIsEditing(false)}
        onClick={() => setIsEditing(true)}>
        {isEditing && (
          <TextField
            value={tagName}
            // A default-size field is taller than a grid row, and the cell it sits in is exactly one row high.
            size="small"
            style={{ fontSize: '.875rem', outline: '#3B6FE8' }}
            name="tag-name"
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
                handleSubmitName();
              }
              if (e.code === 'Space') {
                e.stopPropagation();
              }
            }}
            onChange={(e) => handleNameChange(e.target.value)}
            onBlur={() => handleSubmitName()}
            onSubmit={() => handleSubmitName()}
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
          />
        )}
        {!isEditing && (
          <div className="pl-4">
            {updating && <CircularProgress size={20} />}
            {!updating && <TextBlock size="sm14">{tag.name}</TextBlock>}
          </div>
        )}
      </div>
    </div>
  );
}
